import React, { useState } from "react";

import Cards from "../../components/Cards";
import Layout from "../../components/Layout";
import useFetchWithScroll from "../../hooks/useFetchWithScroll";
import { API_KEY } from "../../utils/constants";

const TopRated = () => {
  const [page, setPage] = useState(1);
  const { data, totalPage, isFetching } = useFetchWithScroll(
    `movie/top_rated?api_key=${API_KEY}&language=en-US&page=${page ? page : 1}`,
    page,
    setPage
  );

  return (
    <Layout title="Top Rated">
      <Cards
        title="Top Rated Movies"
        data={data}
        isFetching={isFetching}
        page={page}
        totalPage={totalPage}
      />
    </Layout>
  );
};

export default TopRated;
